import { FC } from 'react';
import Image from '@base/lib/ThemeImage';
import { isPhone } from 'base/utils/client';
import styles from './index.module.less';

type IPlantProps = {
    src: string;
};
export const Plant: FC<IPlantProps> = props => {
    const { src } = props;

    return (
        <Image
            className={styles.plant}
            width={isPhone ? 160 : 210}
            src={src}
            fixed
            background={false}
        />
    )
};
